import api from "./services";


// All Get Calls

export const fetchTestimonials = async () => {
    try {
        const data = await api("GET", "testimonials");
        return data;
    } catch (error) {
        console.error("Error fetching testimonials:", error);
        throw error;
    }
};

export const fetchBooks = async () => {
    try {
        const booksData = await api("GET", "books");
        return booksData;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export const fetchCategories = async () => {
    try {
        const res = await api("GET", "books-category");
        return res;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const fetchAuthors = async () => {
    try {
        const res = await api("GET", "authors");
        return res;
    } catch (error) {
        console.log(error);
        throw error;
    }
};
export const fetchDeletedBooks = async () => {
    try {
        const res = await api("GET", "deleted-books");
        return res;
    } catch (error) {
        console.error("Error fetching deleted books:", error);
        throw error;
    }
};
export const fetchAnnouncements = async () => {
    try {
        const res = await api("GET", "announcements");
        return res;
    } catch (error) {
        console.error("Error fetching announcements:", error);
        throw error;
    }
};

// Get by Id calls
export const fetchAuthorById = async (id) => {
    try {
        const res = await api("GET", `authors/${id}`);
        return res;
    } catch (error) {
        console.error(`Error fetching author ${id}:`, error);
        throw error;
    }
};

export const fetchBookById = async (id) => {
    try {
        // Based on your component's URL structure: bookById?id=...
        const res = await api("GET", `bookById?id=${id}`);
        return res;
    } catch (error) {
        console.error(`Error fetching book ${id}:`, error);
        throw error;
    }
};



// POST Calls
export const addBookCategory = async (categoryData) => {
    try {
        const res = await api("POST", "add-books-category", categoryData, true);
        return res;
    } catch (error) {
        console.error("Error adding category:", error);
        throw error;
    }
};

export const updateBookCategory = async (id, categoryData) => {
    try {
        const res = await api("POST", `update-book-category/${id}`, categoryData, true);
        return res;
    } catch (error) {
        console.error("Error updating category:", error);
        throw error;
    }
};
export const addAuthor = async (formData) => {
    try {
        const res = await api("POST", "add-authors", formData, true);
        return res;
    } catch (error) {
        console.error("Error adding author:", error);
        throw error;
    }
};

export const updateAuthor = async (id, formData) => {
    try {
        const res = await api("POST", `update-authors/${id}`, formData, true);
        return res;
    } catch (error) {
        console.error("Error updating author:", error);
        throw error;
    }
};
export const addBook = async (formData) => {
    try {
        const res = await api("POST", "add-book", formData, true);
        return res;
    } catch (error) {
        console.error("Error adding book:", error);
        throw error;
    }
};

export const updateBook = async (id, formData) => {
    try {
        const res = await api("POST", `update-book/${id}`, formData, true);
        return res;
    } catch (error) {
        console.error("Error updating book:", error);
        throw error;
    }
};

export const addTestimonial = async (testimonialData) => {
    try {
        const data = await api("POST", "add-testimonial", testimonialData);
        return data;
    } catch (error) {
        console.error("Error adding testimonial:", error);
        throw error;
    }
};
export const updateTestimonial = async (id, testimonialData) => {
    try {
        const data = await api("PUT", `update-testimonial/${id}`, testimonialData);
        return data;
    } catch (error) {
        console.error("Error updating testimonial:", error);
        throw error;
    }
};
export const addAnnouncement = async (formData) => {
    try {
        const res = await api("POST", "add-announcement", formData);
        return res;
    } catch (error) {
        console.error("Error adding announcement:", error);
        throw error;
    }
};

export const updateAnnouncement = async (id, formData) => {
    try {
        const res = await api("POST", `update-announcement/${id}`, formData);
        return res;
    } catch (error) {
        console.error("Error updating announcement:", error);
        throw error;
    }
};

export const resetAdminPassword = async (resetData) => {
    try {
        // We use a POST request for security
        const res = await api("POST", "forgot-password", resetData);
        return res;
    } catch (error) {
        console.error("Reset password error:", error);
        throw error;
    }
};

// Delete api calls
export const deleteTestimonial = async (id) => {
    try {
        // Change 'testimonial' to 'delete-testimonial' to match your PHP route
        const data = await api("DELETE", `delete-testimonial/${id}`);
        return data;
    } catch (error) {
        throw error;
    }
};
export const deleteAnnouncement = async (id) => {
    try {
        const res = await api("DELETE", `delete-announcement/${id}`);
        return res;
    } catch (error) {
        console.error("Error deleting announcement:", error);
        throw error;
    }
};


// Dashboard apis

export const fetchDashboardCounts = async () => {
    try {
        const data = await api("GET", "dashboard-counts");
        return data;
    } catch (error) {
        console.error("Error fetching dashboard stats:", error);
        throw error;
    }
};

// --- Banner Management API Calls ---

export const fetchBanners = async () => {
    try {
        const res = await api("GET", "header-banner");
        return res;
    } catch (error) {
        console.error("Error fetching banners:", error);
        throw error;
    }
};

export const addBanner = async (formData) => {
    try {
        // Passing true/multipart configurations if your api client requires boundary matching flags
        const res = await api("POST", "add-header-banner", formData, true);
        return res;
    } catch (error) {
        console.error("Error adding banner:", error);
        throw error;
    }
};

export const deleteBanner = async (id) => {
    try {
        const res = await api("DELETE", `delete-header-banner/${id}`);
        return res;
    } catch (error) {
        console.error(`Error deleting banner ${id}:`, error);
        throw error;
    }
};